<template>
  <div>
    <Sidebar />
    <Content :siteName="$route.params.siteName" :ccusSiteId="$route.params.ccusSiteId" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar.vue'; // @ is an alias to /src
import Content from '@/components/SiteAttendance.vue'; // @ is an alias to /src

@Component({
  components: {
    Sidebar,
    Content,
  },
})
export default class SiteAttendance extends Vue {}
</script>
